<template>
  <b-modal ref="taskForm" centered size="lg" id="taskForm" hide-header hide-footer>
    <h1 class="edit-task-header text-left">{{taskTitle()}}</h1>
    <hr>
    <b-form class="text-left" @submit.stop.prevent="handleSubmit">
      Task Name
      <b-form-input type="text"
                    required
                    placeholder="Edit Task Name"
                    v-model="taskObject.text">
      </b-form-input>
      Client
      <v-select v-model="taskObject.client_object" value="taskObject.client.name" :options="clients" required />
      Board
      <b-form-select v-model="taskObject.board_id" :options="boards_collection" class="mb-3" required />
      Ticket
      <div class="row">
        <div class="col-sm-12">
          <b-form-select v-model="taskObject.ticket_id" :options="tickets_collection" class="mb-3" required />
        </div>
      </div>
      Due Date
      <div class="row">
        <div class="col-sm-12">
          <date-picker type="text" :config="{format: 'YYYY-MM-DD'}" v-model="taskObject.due_date"></date-picker>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col-sm-5 col-xs-10">
            <b-form-select v-model="taskObject.status" :options="taskObject.statuses" class="mb-3" required />
        </div>
        <div class="col-sm-5 col-xs-10">
            <b-form-select v-model="taskObject.priority" :options="taskObject.priorities" class="mb-3" required />
        </div>
        <div class="col-sm-12">
          Task Owner
          <SingleUserSelector v-on:user-change="taskObject.owner = $event" v-on:user-remove="taskObject.owner = {}" :parent="taskObject" :parentPath="'task'"/>
        </div>
        <div v-if="taskObject.id !== null" class="col-sm-12 request-members">
          Task Users
          <MultiUserSelector :parent="taskObject" :parentPath="'task'"/>
        </div>
      </div>
      Team Notes
      <b-form-textarea id="edit-task"
                       placeholder="Team Notes"
                       v-model="taskObject.team_notes"
                       :rows="3"
                       :max-rows="6">
      </b-form-textarea>
      Client Notes
      <b-form-textarea id="edit-task"
                       placeholder="Client Notes"
                       v-model="taskObject.client_notes"
                       :rows="3"
                       :max-rows="6">
      </b-form-textarea>
      <div>Team View Only (Hides from client)<b-form-checkbox v-model="taskObject.team_view_only" class="team-view-check"></b-form-checkbox></div>
      <br>
      <b-button class="edit-task-btn" type="submit">Submit</b-button>
      <b-button v-if="task.id" @click="deleteTask" variant="danger">Delete</b-button>
      <b-btn class="close-task-btn float-right" @click="hideModal">Close</b-btn>
    </b-form>
      <template v-if="task.hasOwnProperty('id')">
        <br>
        <h6> Task Notes </h6>
        <MessageNotes :notes="taskObject.notes"/>
        <NewNote v-show="true" :entity_with_note_type="'Task'" :entity_with_note_id="taskObject.id"/>
      </template>
  </b-modal>
</template>

<script>
import { collectionsMixins } from '@/mixins/collectionsMixins'
import { mapGetters } from 'vuex'
import SingleUserSelector from './selectors/users/SingleUserSelector.vue'
import MultiUserSelector from './selectors/users/MultiUserSelector.vue'
import MessageNotes from './MessageNotes'
import NewNote from './NewNote'
export default {
  name: 'TaskForm',
  mixins: [collectionsMixins],
  props: {
    task: Object
  },
  components: {
    SingleUserSelector,
    MultiUserSelector,
    NewNote,
    MessageNotes
  },
  data () {
    return {
      taskObject: {},
      boards_collection: [],
      tickets_collection: [],
      client: {}
    }
  },

  created () {
    this.initTask()
  },

  watch: {
    task () {
      this.initTask()
    }
  },

  computed: {
    ...mapGetters(['clients'])
  },

  methods: {
    initTask () {
      if (this.task && (this.task.id || this.task.clone)) {
        this.taskObject = this.task
        if (this.task.client) {
          this.client = {label: this.task.client.name, value: this.task.client.id}
        }
      } else {
        this.getBlankTask(this.task.ticket_id)
      }
    },

    getBlankTask (ticketId) {
      var vm = this
      this.$http.get('/tasks/new', { params: { ticket_id: ticketId } })
        .then(function (response) {
          vm.taskObject = response.data
          vm.taskObject.ticket_id = ticketId
        })
        .catch(e => { console.log(e.response) })
    },

    handleSubmit () {
      var vm = this
      vm.taskObject.client_id = vm.taskObject.client_object.value
      if (vm.taskObject.id) {
        this.$http.put('/tasks/' + vm.taskObject.id, { task: vm.taskObject })
          .then(response => this.submitSuccessful(response, vm.taskObject.ticket_id))
          .catch(e => { console.log(e.response) })
      } else {
        this.$http.post('/tasks', { task: vm.taskObject })
          .then(response => this.submitSuccessful(response, vm.taskObject.ticket_id))
          .catch(e => { console.log(e.response) })
      }
    },
    submitSuccessful (response, ticketId) {
      this.taskObject = {}
      this.$root.$emit('reloadTasks', ticketId)
      this.hideModal()
    },
    deleteTask () {
      var del = confirm('Are you sure?')
      if (del === true) {
        var vm = this
        this.$http.delete('/tasks/' + this.taskObject.id)
          .then(function (response) {
            vm.submitSuccessful(response, vm.taskObject.ticket_id)
          })
          .catch(e => { console.log(e.response) })
      }
    },
    hideModal () {
      this.$root.$emit('bv::hide::modal', 'taskForm')
    },
    loadCollections () {
      this.boardsCollection()
      this.ticketsCollection()
    },
    taskTitle () {
      if (this.taskObject.id) {
        return 'Edit Task'
      } else if (this.taskObject.clone) {
        return 'Clone Task'
      } else {
        return 'New Task'
      }
    }
  },
  mounted () {
    this.$root.$on('taskEdit', () => {
      this.loadCollections()
    })
  }
}
</script>

<style scoped>
#editTask h1 {
  color: #6c757d;
  font-weight: bold;
}
#editTask li {
  display: inline-block;
  margin-right: 20px;
}
#editTask li a {
  color: #6c757d;
  text-decoration: none;
}
#editTask li a:hover {
  border-bottom: 3px solid #57B2CD;
  margin-top: -4px;
}
#editTask ul {
  padding-left: 10px;
}
#editTask .form-control {
  margin-bottom: 20px;
}
#editTask .radio-desc {
  margin-left: 30px;
  opacity: .5;
}
.edit-task-btn {
  background-color: #57B2CD;
  border-color: #57B2CD;
}
.edit-task-btn:hover {
  background-color: #3D92AB;
}
.modal-content {
  max-width: 600px;
  margin: 0 auto;
  padding: 10px;
}
.hidden-checkbox {
    margin-bottom: 25px;
    margin-left: 10px;
}
.team-view-check {
  padding-left: 30px;
  padding-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/TaskForm.vue